import { format, utcToZonedTime } from 'date-fns-tz';

import { textoDaContagem } from 'utils/strings';

/** Percentuais de atuação do cadastro, com o nome de cada faixa. */
export const ATUACOES = [
  { valor: 25, nome: 'Pontual' },
  { valor: 50, nome: 'Parcial' },
  { valor: 75, nome: 'Substancial' },
  { valor: 100, nome: 'Integral' },
];

/** O `team` pode trazer o percentual como texto ("50") ou sem ele; sem número não há o que mostrar nem reduzir. */
export function percentualDaAtuacao(gravado: unknown): number | undefined {
  if (gravado === undefined || gravado === null || gravado === '') return undefined;
  const valor = Number(gravado);
  return Number.isFinite(valor) ? valor : undefined;
}

export function rotuloDaAtuacao(percentual: number): string {
  const nome = ATUACOES.find(atuacao => atuacao.valor === percentual)?.nome;
  return nome ? `${percentual}% · ${nome}` : `${percentual}%`;
}

/** Data da entrega no mesmo fuso que o `TaskItem` usa (`getFormattedDate`), com o ano por extenso do design. */
function dataDaEntrega(valor: unknown, padrao = 'dd/MM/yyyy'): string {
  try {
    return format(utcToZonedTime(valor as number, 'GMT'), padrao);
  } catch {
    return '---';
  }
}

/** Período da entrega no cartão da fila (RDV-29): "dd/mm a dd/mm/aaaa", no mesmo fuso; sem as datas, "---". */
export function periodoDaEntregaNaFila(inicio: unknown, fim: unknown): string {
  if (!inicio || !fim) return '---';
  return `${dataDaEntrega(inicio, 'dd/MM')} a ${dataDaEntrega(fim)}`;
}

/** Quantidade de participantes: `target` quando a leitura o traz, senão `team`. */
export function quantidadeDeParticipantes(data: any): number {
  if (Array.isArray(data.target) && data.target.length) return data.target.length;
  return Array.isArray(data.team) ? data.team.length : 0;
}

function Campo({ rotulo, children }: { rotulo: string; children: string }) {
  return (
    <div className="min-w-0">
      <dt className="mb-[5px] text-[9.5px] uppercase tracking-[0.05em] text-content-soft">{rotulo}</dt>
      <dd className="m-0 text-xs leading-[1.5] text-content">{children}</dd>
    </div>
  );
}

export interface CamposDaRealizacaoProps {
  data: any;
  /** Percentual do usuário no `team`; sem ele, "Sua atuação" não aparece. */
  percentual: number | undefined;
}

/** Campos do cartão (RDV-19): Indicador, Período da entrega, Sua atuação e Participantes. */
export default function CamposDaRealizacao({ data, percentual }: CamposDaRealizacaoProps) {
  return (
    <dl className="m-0 grid grid-cols-2 gap-3.5 border-t border-surface-200 pt-3 md:grid-cols-4">
      <Campo rotulo="Indicador">{data.indicator?.nome || '---'}</Campo>
      <Campo rotulo="Período da entrega">{`${dataDaEntrega(data.start)} a ${dataDaEntrega(data.end)}`}</Campo>
      {typeof percentual === 'number' && <Campo rotulo="Sua atuação">{rotuloDaAtuacao(percentual)}</Campo>}
      <Campo rotulo="Participantes">{textoDaContagem(quantidadeDeParticipantes(data), 'funcionário', 'funcionários')}</Campo>
    </dl>
  );
}
